import { ErrorMessage } from '@helvetia/components/forms/Input/Input.styles'
import * as React from 'react'

interface Props {
  field: any
  form: any
  label: string
  defaultChecked?: boolean
  required?: boolean
  onSelection: () => void
}

export const CheckboxField: React.SFC<Props> = ({
  field,
  form,
  label,
  defaultChecked,
  required,
  onSelection,
}) => (
  <div>
    <label
      className={`uxc-a-lead-checkbox uxc-a-lead-checkbox--display-list ${
        required ? 'uxc-state-a-lead-checkbox--is-required' : ''
      }`}
      data-t-name="UXCCheckbox"
    >
      <input
        id={field.name}
        {...field}
        className="uxc-a-lead-checkbox__input uxc-js-a-lead-checkbox__input"
        type="checkbox"
        value={field.value}
        defaultChecked={defaultChecked}
        onChange={onSelection}
      />
      <span className="uxc-a-lead-checkbox__body">
        <span className="uxc-a-lead-checkbox__box" />
        <span className="uxc-a-lead-checkbox__label">{label}</span>
      </span>
    </label>
    {form.errors[field.name] &&
      (form.submitCount > 0 && (
        <ErrorMessage>{form.errors[field.name]}</ErrorMessage>
      ))}
  </div>
)
